export const renderLastMessage = (
    msg: {
        type: string
        text?: string
        attachments_count?: number
    } | null
) => {
    if (!msg) return "No messages yet"

    if (msg.type === "image") {
        const count = msg.attachments_count ?? 1
        return `📷 Image (${count})`
    }

    if (msg.type === "file") {
        return "📎 File"
    }

    return msg.text || "Message"
}

export const formatDate = (iso?: string | null) => {
    if (!iso) return ""

    const d = new Date(iso)
    const now = new Date()

    const isToday =
        d.toDateString() === now.toDateString()

    return isToday
        ? d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
        : d.toLocaleDateString([], { day: "2-digit", month: "2-digit" })
}
